import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const Leave = withDefaultIconProps(
  {
    height: 30,
    width: 30,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 50 50">
      <Path d="M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z" fill={color} />
      <Path d="M24 7h2v21h-2z" fill={color} />
      <Path
        d="M37 40H13c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h24c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z"
        fill={color}
      />
    </Svg>
  ),
);
